export class Scopes {
  public static timeFormat: string = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

  public static getData(scope = 'data'){
    return App.store.getState()[scope]
  }
  public static dataScopeOrder(id){          return 'order_' + id; }
  public static dataScopeLine(id){           return 'line_' + id; }
  public static dataScopeTask(id){           return 'task_' + id; }
  public static dataScopeSchedule(id){       return 'schedule_' + id; }
  public static dataScopePhase(id){          return 'phase_' + id; }
  public static dataScopeMaterial(id){        return 'material_' + id; }
  public static dataScopeDeliveryOption(id){  return 'delivery_option_' + id; }
  public static dataScopeDeliveryRecord(taskable_id) { return 'delivery_record_' + taskable_id; }
  public static dataScopeDeliveryRecordSum(taskable_id) { return 'delivery_record_sum_' + taskable_id}
  public static dataScopeTaskable(id, type){
    if(type == 'Tasks::Delivery'){
      return 'taskable_delivery_' + id;
    } else if(type == 'Tasks::Casting'){
      return 'taskable_casting_' + id;
    }
  }
  public static dataScopeUser(id){                return 'user_' + id; }
  public static getScopeNotification(id){         return 'notification_' + id; }
  public static getScopeCurrentUser(){            return 'login_user'; }
  public static dataScopeLocation(id){            return 'location_' + id; }
  public static dataScopeLocationsPerson(id){     return 'locations_person_' + id; }
  public static dataScopeTasksMemo(composite_id){ return 'tasks_memo_' + composite_id};
  public static dataScopeMenu(){                  return 'orders_planner_dialog_line_menu'}
  public static dataScopeCommentsNotifications(id) { return 'comments_notifications_' + id; }

  public static getCurrentUser(){    return this.getData()[this.getScopeCurrentUser()]}
  public static getPlannerData(){    return this.getData('planner').orders_planner; }
  public static getOrderData(id){    return this.getData('orders')[this.dataScopeOrder(id)]; }
  public static getLineData(id){     return this.getData('lines')[this.dataScopeLine(id)]; }
  public static getTaskData(id){     return this.getData('tasks')[this.dataScopeTask(id)]; }
  public static getScheduleData(id){ return this.getData('schedules')[this.dataScopeSchedule(id)]; }
  public static getPhaseData(id){    return this.getData()[this.dataScopePhase(id)]; }
  public static getPhaseDataByIdentity(identity){
    let d = this.getData()
    let id = d['phase_index'][identity];
    return this.getPhaseData(id);
  }
  public static getMaterialData(id){ return this.getData()[this.dataScopeMaterial(id)]; }
  public static getDeliveryOptionData(id){      return this.getData()[this.dataScopeDeliveryOption(id)]; }
  public static getTaskableData(id, type){      return this.getData('taskables')[this.dataScopeTaskable(id, type)]; }
  public static getLocationData(id){            return this.getData('locations')[this.dataScopeLocation(id)]; }
  public static getLocationsPersonData(id){     return this.getData('locations')[this.dataScopeLocationsPerson(id)]; }
  public static getTasksMemoData(composite_id){ return this.getData('memos')[this.dataScopeTasksMemo(composite_id)]}
  public static getFormCreateData(){            return this.getData()['forms_schedules_create']; }
  public static getFormUpdateData(){            return this.getData()['forms_schedules_update']; }
  public static getFormTaskUpdateData(){        return this.getData()['forms_tasks_update']; }
  public static getFormTasksMemoData(){         return this.getData()['forms_tasks_memo_save']; }
  public static getFormScheduleDestroyData() {  return this.getData()['forms_schedules_destroy']; }
  public static getMenuPayloads(){              return this.getData('planner')[this.dataScopeMenu()].payloads; }
  public static getUserData(id){                return this.getData()[this.dataScopeUser(id)]; }
  public static getNotificationData(id){        return this.getData()[this.getScopeNotification(id)]; }
  public static getCurrentUserData(){           return this.getData()[this.getScopeCurrentUser()]; }
  public static getCommentsNotificationsData(id){ return this.getData()[this.dataScopeCommentsNotifications(id)]; }
  public static getDeliveryRecordData(taskable_id){ return this.getData()[this.dataScopeDeliveryRecord(taskable_id)]; }
  public static getDeliveryRecordSumData(taskable_id){ return this.getData()[this.dataScopeDeliveryRecordSum(taskable_id)]; }

  public static getPartitionPayload() { return this.getData('planner').tasks_memo_partition_payload; }

  public static getTaskDataByScheduleId(scheduleId){
    let scheduleData = Scopes.getScheduleData(scheduleId);
    return Scopes.getTaskData(scheduleData.task_id);
  }
}
